import React from 'react';
import { mediaUrl } from '../../api/client';

export default function IconBoxes({ section }) {
  const d = section.data || {};
  const items = (d.items || []).filter((i) => i.title);
  if (!items.length) return null;
  return (
    <section className="sf-icon-box sf__index-icon-box-1" style={{ backgroundColor: d.background || 'rgba(0,0,0,0)' }}>
      <div className="container section-my" style={{ '--column-gap': '30px', '--column-gap-mobile': '10px', '--row-gap': '40px' }}>
        <div className="sf__ms">
          <div className={`sf-grid grid grid-cols-2 md:grid-cols-2 lg:grid-cols-${Math.min(items.length, 4)} gap-x-6 gap-y-10`}>
            {items.map((it, i) => (
              <div className="sf-column" key={i}>
                <div className="sf-icon-box sf-icon-box--horizontal">
                  <div className="sf-icon-box__inner flex flex-col justify-center sm:items-start sm:flex-row flex-nowrap items-center">
                    <div className="sf-icon-box__icon w-full flex flex-shrink-0 justify-center max-w-full mb-5 md:mb-0 items-start pt-1" style={{ width: `${d.iconSize || 30}px` }}>
                      {it.icon ? <div className="sf-image w-full"><img src={mediaUrl(it.icon)} alt="" className="w-full" loading="lazy" /></div> : null}
                    </div>
                    <div className="sf-icon-box__text flex-1 sm:text-left text-center sm:ml-4">
                      <h3 className="h4 mb-1.5 font-medium">{it.title}</h3>
                      <div className="rte text-color-subtext"><p>{it.text}</p></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
